export enum PatientSourceType {
    None = 0,
    OutPatient = 1,
    Emergency = 2,
    InPatient = 3,
}